import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { Application } from '@fides/fides-react-components';
import { ApplicationHeaderPage } from 'components/shared/ApplicationHeaderPage';
import { useGlobalConfigContext } from 'core/contexts/GlobalConfig';
import { GlobalConfig } from 'core/interfaces';
import { EndUserHeader } from 'components/shared/EndUserHeader';
import { PrivateRoute } from '../helpers';

const Overview = React.lazy(() => import('../../components/pages/DLC'));
const Detail = React.lazy(() => import('../../components/pages/DLC/Detail'));

const RenderWithHeader = ({ user, hasAccessToDLC, children, pageTitle }) => {
  if (!hasAccessToDLC) {
    return <Redirect to='/page-not-found' />;
  }

  if (user?.isPartnerEndUser || user?.isCorporateEndUser) {
    return <EndUserHeader>{children}</EndUserHeader>;
  }

  return (
    <ApplicationHeaderPage pageTitle={pageTitle} variant='medium' displayCompanyLogo>
      {children}
    </ApplicationHeaderPage>
  );
};

export const DownloadCenterRouter = () => {
  const globalConfig: GlobalConfig = useGlobalConfigContext();
  const { user, hasUserAppAccess } = globalConfig;
  const hasAccessToDLC = hasUserAppAccess(Application.DLCWEB);

  return (
    <Switch>
      <Redirect from='/DLC/' to='/DLC/overview' exact />
      <PrivateRoute path='/DLC/overview' exact>
        <RenderWithHeader user={user} hasAccessToDLC={hasAccessToDLC} pageTitle='PAGE_TITLE.OVERVIEW.REPORTS'>
          <Overview />
        </RenderWithHeader>
      </PrivateRoute>
      <PrivateRoute path='/DLC/viewReport/:uniqueId' exact>
        <RenderWithHeader user={user} hasAccessToDLC={hasAccessToDLC} pageTitle=''>
          <Detail />
        </RenderWithHeader>
      </PrivateRoute>
      <Redirect to='/page-not-found' />
    </Switch>
  );
};
